import { CircularProgress } from '@mui/material';
import React from 'react';

const Loading: React.FC = () => <CircularProgress />;

export default Loading;
